import { render, staticRenderFns } from "./ProAlerta.vue?vue&type=template&id=2845c5c1"
import script from "./ProAlerta.vue?vue&type=script&defer=true&lang=js"
export * from "./ProAlerta.vue?vue&type=script&defer=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports